// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"4a4066ff","165":"94f0df68","453":"e0f5069b","871":"3df48b78"}[chunkId] + ".chunk.js";
};